export default "__VITE_ASSET__BXtq2TFC__"